const MainHeader = () => {
  return (
    <>
      <div className="main-header">
        <div>
          <h1>O nas</h1>
          <p>
            Jesteśmy Pierwszą szkołą strip dance w Polsce. Tworzymy bezpieczną
            przestrzeń dla kobiet, które pragną odkryć swoje piękno i poczuć się
            zmysłowo. Obudź swoją kobiecą energię z Nami!
          </p>
        </div>
      </div>
    </>
  );
};

export default MainHeader;
